// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { Tile, TileSize, ThumbnailsList, TileSizeMobile } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid8S = class TeaserBoxInnerGrid8S extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE,
            tiles: {
                0: TileSize.S
            },
            listOffset: 8,
            listType: false
        };
    }
};
TeaserBoxInnerGrid8S.moduleVersion = TeaserBoxVersion['8S'];
TeaserBoxInnerGrid8S = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid8S',
        components: { InnerGridWrapper, Tile, ThumbnailsList },
        template: `

    <InnerGridWrapper>
    <template v-if="items && items.length">
      <!-- Left column (1/4): Tiles and Addons -->
      <template v-if="!isMobile && listComponent">
        <div :class="gridStyle">
          <component :is="listComponent.component" v-bind="getComponentProps(listComponent)"
                     :key="listComponent.key" />
        </div>
      </template>
      <!-- Right column (3/4): TextList with Addons -->
      <template v-for="item in tiles">
        <component :is="getComponentType(item)" v-bind="getComponentProps(item)" :key="item.key" />
      </template>
    </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGrid8S);
export { TeaserBoxInnerGrid8S };
